// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ContentLoaderController from "./content_loader_controller"
application.register("content-loader", ContentLoaderController)

import ContentLoaderDivController from "./content_loader_div_controller"
application.register("content-loader-div", ContentLoaderDivController)

import FormSuccesMessageController from "./form_succes_message_controller"
application.register("form-succes-message", FormSuccesMessageController)

import OpenModalDialogController from "./open_modal_dialog_controller"
application.register("open-modal-dialog", OpenModalDialogController)

import PlayButtonController from "./play_button_controller"
application.register("play-button", PlayButtonController)

import RankitoMentionController from "./rankito_mention_controller"
application.register("rankito-mention", RankitoMentionController)

import RankitoPollingController from "./rankito_polling_controller"
application.register("rankito-polling", RankitoPollingController)

import RespuestaController from "./respuesta_controller"
application.register("respuesta", RespuestaController)

import SortableCsvController from "./sortable_csv_controller"
application.register("sortable-csv", SortableCsvController)

import StickyItemController from "./sticky_item_controller"
application.register("sticky-item", StickyItemController)

import SuscripcionesController from "./suscripciones_controller"
application.register("suscripciones", SuscripcionesController)

import TableSliderController from "./table_slider_controller"
application.register("table-slider", TableSliderController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TraducirController from "./traducir_controller"
application.register("traducir", TraducirController)

import TrixWordCountController from "./trix_word_count_controller"
application.register("trix-word-count", TrixWordCountController)

import VerArbolDeCategoriasController from "./ver_arbol_de_categorias_controller"
application.register("ver-arbol-de-categorias", VerArbolDeCategoriasController)

import VerMasController from "./ver_mas_controller"
application.register("ver-mas", VerMasController)
